export default __webpack_public_path__ + "static/media/d2.8aa75e29.png";